<template>
    <div class="notification-design inner-content stepsBar" id="notficationList">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>New Updates</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" v-if="Notifications && Notifications.data">

                    <div class="row notification-list" v-for="(notification, x) in Notifications.data" :key="x" v-if="notification.data">
                        <div class="col-md-9 col">
                            <h3 v-html="notification.data.title" v-if="notification.data.title"></h3>
                            <p v-html="notification.data.sub_title" v-if="notification.data.sub_title"></p>
                            <p v-html="notification.data.description" v-if="notification.data.description" class="noti_desc"></p>
                        </div>
                        <div class="col-md-3 col">
                            <a href="javascript:void(0);" class="checknow-btn btn" @click="update_notification(notification)" v-if="notification.read_at===null">Check Now</a>

                            <div class="checknoti">
                                <input id="check1" class="checkbox-custom" name="checkbox-1" type="checkbox"
                                    :checked="notification.read_at" disabled>
                                <label for="check1" class="checkbox-custom-label"></label>
                            </div>
                        </div>
                    </div>

                  <!--   <div class="row notification-list">
                        <div class="col-md-9 col">
                            <h3><a href="#">Productt Status Has Change By Vendor</a></h3>
                            <p><span>Order # :</span><span>1002317067</span></p>
                            <p><span>WeVisu Customer:</span><span>Jonathan Cohen</span></p>
                        </div>
                        <div class="col-md-3 col">
                            <a href="#" class="checknow-btn btn">Check Now</a>

                            <div class="checknoti">
                                <input id="check2" class="checkbox-custom" name="checkbox-1" type="checkbox" checked>
                                <label for="check2" class="checkbox-custom-label"></label>
                            </div>
                        </div>
                    </div>

                    <div class="row notification-list">
                        <div class="col-md-9 col">
                            <h3><a href="#">Productt Shipped!</a></h3>
                            <p><span>Order # :</span><span>1002317067</span></p>
                            <p><span>WeVisu Customer:</span><span>Jonathan Cohen</span></p>
                        </div>
                        <div class="col-md-3 col">
                            <a href="#" class="checknow-btn btn">Check Now</a>

                            <div class="checknoti">
                                <input id="check3" class="checkbox-custom" name="checkbox-1" type="checkbox">
                                <label for="check3" class="checkbox-custom-label"></label>
                            </div>
                        </div>
                    </div>

                    <div class="row notification-list">
                        <div class="col-md-9 col">
                            <h3><a href="#">New Message!</a></h3>
                            <p><span>WeVisu Customer:</span><span>Jonathan Cohen</span></p>
                        </div>
                        <div class="col-md-3 col">
                            <a href="#" class="checknow-btn btn">Check Now</a>

                            <div class="checknoti">
                                <input id="check4" class="checkbox-custom" name="checkbox-1" type="checkbox">
                                <label for="check4" class="checkbox-custom-label"></label>
                            </div>
                        </div>
                    </div>

                    <div class="row notification-list">
                        <div class="col-md-9 col">
                            <h3><a href="#">Your Productt in Now Available</a></h3>
                            <p><span>Product:</span><span>Productt name and number here</span></p>
                        </div>
                        <div class="col-md-3 col">
                            <a href="#" class="checknow-btn btn">Check Now</a>

                            <div class="checknoti">
                                <input id="check5" class="checkbox-custom" name="checkbox-1" type="checkbox">
                                <label for="check5" class="checkbox-custom-label"></label>
                            </div>
                        </div>
                    </div>


                    <div class="row notification-list">
                        <div class="col-md-9 col">
                            <h3><a href="#">Add to Cart!</a></h3>
                            <p><span>Product:</span><span>Productt name and number here</span></p>
                        </div>
                        <div class="col-md-3 col">
                            <a href="#" class="checknow-btn btn">Check Now</a>

                            <div class="checknoti">
                                <input id="check6" class="checkbox-custom" name="checkbox-1" type="checkbox">
                                <label for="check6" class="checkbox-custom-label"></label>
                            </div>
                        </div>
                    </div>

                    <div class="row notification-list">
                        <div class="col-md-9 col">
                            <h3><a href="#">New Checklist Updte</a></h3>
                            <p><span>WeVisu Customer:</span><span>Jonathan Cohen</span></p>
                        </div>
                        <div class="col-md-3 col">
                            <a href="#" class="checknow-btn btn">Check Now</a>

                            <div class="checknoti">
                                <input id="check7" class="checkbox-custom" name="checkbox-1" type="checkbox">
                                <label for="check7" class="checkbox-custom-label"></label>
                            </div>
                        </div>
                    </div> -->
                    <UjPagination @fetchRecord="val=>fetchNotifications(val)" :records="Notifications" :ppp.sync="ppp" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from "vuex";
export default {
    name: "Notifications",
    data() {
        return {
            pageLoader: '',
            ppp: 10
        }
    },
    computed: {
        ...mapGetters("Common", ["Notifications", "PendingNotification"])
    },
    methods: {
        ...mapActions("Common", ["getNotifications", "updateNotification"]),

        async fetchNotifications(val='') {
            this.pageLoader = this.$loading.show({
                container: this.$refs.main_ref
            });
            await this.getNotifications({
                    ppp: this.ppp,
                    url:val
                })
                .then(() => {
                    this.contentScroll('notficationList');
                    this.pageLoader.hide()
                })
                .catch(err => {
                    this.pageLoader.hide()
                });
        },

        async update_notification(notification){

            await this.updateNotification(notification)
            .then((res)=>{
                notification.read_at= new Date()
            })
        }
    },
    created() {
        this.fetchNotifications()
    },
    mounted() {

    },
    beforeDestroy() {
        this.pageLoader.hide();
    },
}
</script>
